import moment from "moment"
import BigCalendar from "react-big-calendar"
//

export const localizer = BigCalendar.momentLocalizer(moment)

const monthIndicies = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12"
}

export const getMomentFromMonthYearString = (monthYear) => {
  const monthParts = monthYear.split(" ")
  return moment(`${monthParts[1]}-${monthIndicies[monthParts[0]]}`)
}

const filterByMonth = (events, monthYear) => {
  if (monthYear && monthYear !== "All") {
    const monthFullDate = getMomentFromMonthYearString(monthYear)

    return events.filter((event) => {
      const startDate = moment(event.startDate)
      return (
        startDate.get("month") === monthFullDate.get("month") &&
        startDate.get("year") === monthFullDate.get("year")
      )
    })
  } else {
    return events
  }
}

export const filterByProp = (events, propKey, propValue) =>
  events.filter((event) => propValue.toLowerCase().includes(event[propKey].toLowerCase()))

const filterBySearch = (events, filter) =>
  filter
    ? events.filter((event) => {
        return (
          (event.topic &&
            event.topic.toLowerCase().includes(filter.toLowerCase())) ||
          (event.name &&
            event.name.toLowerCase().includes(filter.toLowerCase())) ||
          (event.createdBy &&
            event.createdBy.toLowerCase().includes(filter.toLowerCase())) ||
          (event.summary &&
            event.summary.toLowerCase().includes(filter.toLowerCase())) ||
          (event.campaignName &&
            event.campaignName.toLowerCase().includes(filter.toLowerCase())) ||
          (event.description &&
            event.description.toLowerCase().includes(filter.toLowerCase())) ||
          (event.venue &&
            event.venue.toLowerCase().includes(filter.toLowerCase()))
        )
      })
    : events

export const filterEventsByAll = (events, { search, venue, topic, month }) => {
  let filteredEvents = search ? filterBySearch(events, search) : events

  filteredEvents = month ? filterByMonth(filteredEvents, month) : filteredEvents

  filteredEvents = topic
    ? filterByProp(filteredEvents, "topic", topic)
    : filteredEvents

  filteredEvents = venue
    ? filterByProp(filteredEvents, "venue", venue)
    : filteredEvents

  return filteredEvents
}



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/EventsCalendar/utils.js